<template>
  <layout-main-inner title="活动">
    <layout-card-wrap>
      <el-row :gutter="20">
        <el-col :md="6">
          <activity-card :config="lottery"></activity-card>
        </el-col>
        <el-col :md="6">
          <activity-card :config="discount"></activity-card>
        </el-col>
        <el-col :md="6">
          <activity-card :config="coupon"></activity-card>
        </el-col>
        <el-col :md="6">
          <activity-card :config="coupon1"></activity-card>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :md="6">
          <activity-card :config="receive"></activity-card>
        </el-col>
      </el-row>
    </layout-card-wrap>
  </layout-main-inner>
</template>
<script>
import ActivityCard from './busi/activity-card.vue'
import { mapState } from 'vuex'
const img1 = require('./images/wx.png')
const img2 = require('./images/wx.png')
const img3 = require('./images/coupon.png')
export default {
  name: 'WxappMarketingList',
  components: { ActivityCard },
  props: {},
  data() {
    return {
      lottery: {
        title: '单品抽奖',
        info: '使用积分进行单品抽奖',
        url: '/wxapp-marketing-lottery',
        image: img1
      },
      discount: {
        title: '特惠商品',
        info: '设置商品指标来进行促销',
        url: '/wxapp-marketing-discount',
        image: img2
      },
      coupon: {
        title: '优惠券',
        info: '创建全品/单品满减券',
        url: '/wxapp-marketing-coupon',
        image: img3
      },
      coupon1: {
        title: '报名抽奖',
        info: '无门槛报名抽奖活动',
        url: '/wxapp-marketing-draw',
        image: img3
      },
      receive: {
        title: '线下领礼',
        info: '线下扫码领礼品',
        url: '/wxapp-marketing-receive',
        image: img3
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo
    })
  }
}
</script>
